<template>
  <div v-if="visible" class="modal-overlay" @click.self="handleClose">
    <div class="modal-container">
      <!-- Header -->
      <div class="modal-header">
        <div class="header-content">
          <div class="header-left">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M19.1029 10.39L20.1629 9.33C20.9429 8.55 20.9429 7.28 20.1629 6.5L18.7529 5.09C17.9729 4.31 16.7029 4.31 15.9229 5.09L14.8629 6.15L19.1029 10.39ZM14.8629 11.81L7.66293 19H6.25293V17.59L13.4429 10.4L14.8629 11.81ZM13.4429 7.56L4.25293 16.76V21H8.49293L17.6829 11.81L13.4429 7.56ZM19.2529 17.5C19.2529 19.69 16.7129 21 14.2529 21C13.7029 21 13.2529 20.55 13.2529 20C13.2529 19.45 13.7029 19 14.2529 19C15.7929 19 17.2529 18.27 17.2529 17.5C17.2529 17.03 16.7729 16.63 16.0229 16.3L17.5029 14.82C18.5729 15.45 19.2529 16.29 19.2529 17.5ZM4.83293 13.35C3.86293 12.79 3.25293 12.06 3.25293 11C3.25293 9.2 5.14293 8.37 6.81293 7.64C7.84293 7.18 9.25293 6.56 9.25293 6C9.25293 5.59 8.47293 5 7.25293 5C5.99293 5 5.45293 5.61 5.42293 5.64C5.07293 6.05 4.44293 6.1 4.02293 5.76C3.61293 5.42 3.53293 4.81 3.87293 4.38C3.98293 4.24 5.01293 3 7.25293 3C9.49293 3 11.2529 4.32 11.2529 6C11.2529 7.87 9.32293 8.72 7.61293 9.47C6.67293 9.88 5.25293 10.5 5.25293 11C5.25293 11.31 5.68293 11.6 6.32293 11.86L4.83293 13.35Z" fill="#374957"/>
            </svg>
            <h2 class="modal-title">Add Signature</h2>
          </div>
          <button class="close-button" @click="handleClose">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="#666"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Content -->
      <div class="modal-content">
        <p v-if="data?.description" class="description-text">{{ data.description }}</p>
        <p v-else class="description-text">Add a description or help text ...</p>
        
        <div class="signature-input-area">
          <input
            ref="signatureInput"
            v-model="signatureName"
            type="text"
            class="signature-input"
            placeholder="Type here to sign"
            @keyup.enter="handleSave"
          />
          <div class="signature-line"></div>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <!-- Original:
        <button class="cancel-button" @click="handleClose">
          Cancel
        </button>
        -->
        <ResponsiveButton
          display_name="Cancel"
          button_type="text"
          built_in_theme="dark"
          size="small"
          @click-button="handleClose"
        />
        <!-- Original:
        <button class="save-button" @click="handleSave" :disabled="!signatureName.trim()">
          Save
        </button>
        -->
        <ResponsiveButton
          display_name="Save"
          button_type="filled"
          built_in_theme="dark"
          size="small"
          :disabled="!signatureName.trim()"
          @click-button="handleSave"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignatureModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    initialValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      signatureName: ''
    };
  },
  emits: ['close', 'save'],
  watch: {
    visible(newVal) {
      if (newVal) {
        this.signatureName = this.initialValue;
        // Disable body scroll and focus input
        document.body.style.overflow = 'hidden';
        this.$nextTick(() => {
          this.$refs.signatureInput?.focus();
        });
      } else {
        // Enable body scroll
        document.body.style.overflow = '';
      }
    }
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleSave() {
      if (this.signatureName.trim()) {
        this.$emit('save', this.signatureName.trim());
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-container {
  width: 546px;
  max-width: 90vw;
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
}

/* Header */
.modal-header {
  background: #fff;
  padding: 12px 24px;
  border-radius: 10px 10px 0 0;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-title {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #004879;
  margin: 0;
}

.close-button {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  transition: background 0.2s;
}

.close-button:hover {
  background: rgba(0, 0, 0, 0.05);
}

/* Content */
.modal-content {
  padding: 12px 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.description-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #333;
  margin: 0;
}

.signature-input-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 0 24px;
}

.signature-input {
  width: 100%;
  border: none;
  outline: none;
  font-family: "Brush Script MT", sans-serif;
  font-size: 24px;
  font-style: italic;
  font-weight: 400;
  line-height: 36px;
  color: #999;
  text-align: center;
  background: transparent;
  padding: 8px 0;
}

.signature-input::placeholder {
  font-family: "Inter", sans-serif;
  color: #999;
  font-style: italic;
}

.signature-input:focus {
  color: #333;
}

.signature-line {
  width: 100%;
  height: 1px;
  background: #333;
}

/* Footer */
.modal-footer {
  padding: 12px 24px 23px;
  border-radius: 0 0 10px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cancel-button {
  background: transparent;
  border: none;
  padding: 8px 0;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #1E4670;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.2s;
}

.cancel-button:hover {
  color: #004879;
}

.save-button {
  padding: 8px 32px;
  background: #004879;
  border: none;
  border-radius: 4px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #fff;
  cursor: pointer;
  box-shadow: 0px 1px 3px 0px rgba(74, 74, 74, 0.25);
  transition: background 0.2s;
  height: 40px;
}

.save-button:hover:not(:disabled) {
  background: #1E4670;
}

.save-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
